import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { ChannelType } from "./TuvisMessagingChannels";

export const ALREADY_EXISTS_ERROR = "ALREADY_EXISTS";

export const MessagingContactPhone = Type.Object({
  type: ChannelType,
  phone: Type.Number(),
  name: Type.Optional(Type.String()),
});

export type MessagingContactPhone = TypeBoxToType<typeof MessagingContactPhone>;

const ImContact = Type.Object({
  _id: Type.String(),
  orgId: Type.String(),
  firstName: Type.String(),
  lastName: Type.String(),
  isDeleted: Type.Boolean(),
  createdAt: Type.String(),
  updatedAt: Type.String(),
  phones: Type.Array(MessagingContactPhone),
});

export type ImContact = TypeBoxToType<typeof ImContact>;
